import {genericHashLink} from "react-router-hash-link";
import {Nav} from "react-bootstrap";

const CustomHashLink = (props) => genericHashLink(props, Nav.Link);

export default CustomHashLink;